import { render, staticRenderFns } from "./TransferRejectingCommentModal.vue?vue&type=template&id=9e04a0c2&"
import script from "./TransferRejectingCommentModal.vue?vue&type=script&lang=js&"
export * from "./TransferRejectingCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports